module.exports = __webpack_public_path__ + "assets/img/weibo-7602d258.png";